/**
 * Configuración centralizada de la aplicación
 * Maneja configuraciones para ambientes dev y prod
 */

// Determinar el ambiente actual
// Por defecto es 'dev' si no está definido REACT_APP_ENVIRONMENT
const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'dev';

/**
 * Configuraciones por ambiente
 */
const configs = {
  dev: {
    // Supabase
    supabase: {
      url: 'https://sdhtewszamnjywussslh.supabase.co',
      anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNkaHRld3N6YW1uanl3dXNzc2xoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg1OTYyOTksImV4cCI6MjA3NDE3MjI5OX0.lwXDhEg277AZqexwTdcfZgXlbBXTjNzLp0c59BAURH8',
      projectId: 'sdhtewszamnjywussslh',
    },
    
    // Netlify
    netlify: {
      baseUrl: 'https://dev--patagonia-vital.netlify.app',
      functionsPath: '/.netlify/functions',
    },
    
    // Google Drive (para integraciones)
    google: {
      driveRootFolderId: '1_PJ0deyPeodP_Hccgb-_XAHWH9g1jNIS',
      oauthClientId: '758555783777-ipbbum192h38g8oqbir9pmvrdjtt0cqj.apps.googleusercontent.com',
      isSharedDrive: false,
    },
    
    // Microsoft OneDrive
    microsoft: {
      redirectUri: 'https://dev--patagonia-vital.netlify.app/auth/onedrive/callback',
    },
    
    // AWS Lambda
    lambda: {
      kmsInventarioUrl: 'https://chlpv67zo6vkakrrjomxh7d4740giadh.lambda-url.us-east-2.on.aws/',
      defontanaClientesUrl: 'https://v42t6d7ms2eoja2ezmepvhqc6y0tciaw.lambda-url.us-east-2.on.aws/',
      quickbooksClientesUrl: 'https://2qw4anffs4u5nz5wiqqviuwhnm0gylmr.lambda-url.us-east-2.on.aws/',
      defontanaGuiaDespachoUrl: 'https://grsolxgm6wcw5sxbutnbqaby6y0iesrq.lambda-url.us-east-2.on.aws/',
      defontanaGuiaIngresarUrl: 'https://cbxjps7fnjb52mbowftg6mwwnu0ozhok.lambda-url.us-east-2.on.aws/',
      defontanaFacturaIngresarUrl: 'https://joytis4t6sx4aemk7u4tbjvg7a0ysypw.lambda-url.us-east-2.on.aws/',
      defontanaFacturaLocalIngresarUrl: 'https://pryuycdgljwxpn7jnra7in6dii0nmrkt.lambda-url.us-east-2.on.aws/',
    },
    
    // n8n Webhooks
    n8n: {
      gmailWebhookUrl: 'https://patagoniavital.app.n8n.cloud/webhook/gmail-webhook',
    },
    
    // Configuraciones generales
    app: {
      name: 'Patagonia Vital',
      version: '1.0.0',
      environment: 'development',
      debug: true,
    },
  },
  
  prod: {
    // Supabase
    supabase: {
      url: 'https://nrvrxnveyvgplafhsndl.supabase.co',
      anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ydnJ4bnZleXZncGxhZmhzbmRsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA3MzA4NTgsImV4cCI6MjA3NjMwNjg1OH0.opfEJ_9kClrSyRdhMPATctlzrGsmeVdp32IbX7xTuDY',
      projectId: 'nrvrxnveyvgplafhsndl',
    },
    
    // Netlify
    netlify: {
      baseUrl: 'https://ventas.patagoniavital.com',
      functionsPath: '/.netlify/functions',
    },
    
    // Google Drive (para integraciones)
    google: {
      driveRootFolderId: '1_PJ0deyPeodP_Hccgb-_XAHWH9g1jNIS',
      oauthClientId: '758555783777-ipbbum192h38g8oqbir9pmvrdjtt0cqj.apps.googleusercontent.com',
      isSharedDrive: false,
    },
    
    // Microsoft OneDrive
    microsoft: {
      redirectUri: 'https://ventas.patagoniavital.com/auth/onedrive/callback',
    },
    
    // AWS Lambda
    lambda: {
      kmsInventarioUrl: 'https://5rsls54mu6g3tk3wq6sw5ipwwa0sjyaq.lambda-url.us-east-2.on.aws/',
      defontanaClientesUrl: 'https://ys2hf7c4vguz4xxkyqmx2jsnwa0ttwal.lambda-url.us-east-2.on.aws/',
      quickbooksClientesUrl: 'https://bnzflinq3qhsc2lxjz3e5v2zhq0ukyut.lambda-url.us-east-2.on.aws/',
      defontanaGuiaDespachoUrl: 'https://ixmz5ah5ld5cwl2tzhcm5fkww40dlgcu.lambda-url.us-east-2.on.aws/',
      defontanaGuiaIngresarUrl: 'https://omw6waghthvk2qhd24dovjmdqi0shflz.lambda-url.us-east-2.on.aws/',
      defontanaFacturaIngresarUrl: 'https://j6yb2mig3fjzhzrwh5osgd6yga0ouivz.lambda-url.us-east-2.on.aws/',
      defontanaFacturaLocalIngresarUrl: 'https://32u6jcr3e6o6xkzzi3d4gt3dhy0jytom.lambda-url.us-east-2.on.aws/',
    },
    
    // n8n Webhooks
    n8n: {
      gmailWebhookUrl: 'https://patagoniavital.app.n8n.cloud/webhook/94ba1af7-7201-4bab-be34-c28ca90fc888',
    },
    
    // Configuraciones generales
    app: {
      name: 'Patagonia Vital',
      version: '1.0.0',
      environment: 'production',
      debug: false,
    },
  },
};

/**
 * Configuración activa según el ambiente
 */
const config = configs[REACT_APP_ENVIRONMENT];

// Validar que la configuración existe
if (!config) {
  throw new Error(`Invalid environment: ${REACT_APP_ENVIRONMENT}. Must be 'dev' or 'prod'.`);
}

/**
 * Helper function para construir URL completa de función de Netlify
 * @param {string} functionName - Nombre de la función
 * @param {boolean} cacheBust - Si se debe agregar parámetro para evitar caché (default: false)
 * @returns {string} URL completa
 */
export const getNetlifyFunctionUrl = (functionName, cacheBust = false) => {
  // Detectar si existe la variable de ambiente LOCAL
  const useLocalBackend = process.env.REACT_APP_LOCAL === 'true';
  
  let baseUrl;
  if (useLocalBackend) {
    // Usar backend local cuando REACT_APP_LOCAL=true
    baseUrl = `http://ip-172-31-18-178.us-east-2.compute.internal:9999/.netlify/functions/${functionName}`;
  } else {
    // Usar configuración normal según ambiente (dev/prod)
    baseUrl = `${config.netlify.baseUrl}${config.netlify.functionsPath}/${functionName}`;
  }
  
  // Agregar cache-busting si se solicita
  if (cacheBust) {
    const timestamp = Date.now();
    return `${baseUrl}?_t=${timestamp}`;
  }
  
  return baseUrl;
};

/**
 * Helper function para obtener configuración de Supabase
 * @returns {object} Configuración de Supabase
 */
export const getSupabaseConfig = () => {
  return {
    url: config.supabase.url,
    anonKey: config.supabase.anonKey,
  };
};

/**
 * Helper function para obtener URL de Lambda
 * @param {string} lambdaName - Nombre de la función Lambda
 * @returns {string} URL de la función Lambda
 */
export const getLambdaUrl = (lambdaName) => {
  const lambdaUrls = {
    'kms-inventario': config.lambda.kmsInventarioUrl,
    'defontana-clientes': config.lambda.defontanaClientesUrl,
    'quickbooks-clientes': config.lambda.quickbooksClientesUrl,
    'defontana-guiadespacho': config.lambda.defontanaGuiaDespachoUrl,
    'defontana-guia-ingresar': config.lambda.defontanaGuiaIngresarUrl,
    'defontana-factura-ingresar': config.lambda.defontanaFacturaIngresarUrl,
    'defontana-factura-local-ingresar': config.lambda.defontanaFacturaLocalIngresarUrl,
  };
  
  return lambdaUrls[lambdaName] || null;
};

/**
 * Helper function para obtener URL de webhook n8n
 * @returns {string} URL del webhook de Gmail
 */
export const getN8nWebhookUrl = () => {
  return config.n8n.gmailWebhookUrl;
};

/**
 * Exportar configuración activa
 */
export default config;

/**
 * Exportar ambiente actual
 */
export const environment = REACT_APP_ENVIRONMENT;

/**
 * Exportar flags útiles
 */
export const isDevelopment = REACT_APP_ENVIRONMENT === 'dev';
export const isProduction = REACT_APP_ENVIRONMENT === 'prod';
